var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 分类树管理(商品归属,文章归属,项目归属,各种归属) ")])}
var staticRenderFns = []

export { render, staticRenderFns }